/* unplugin-vue-components disabled */import { render } from "./NotificationParametersTypeNotification.vue?vue&type=template&id=331ea85b&scoped=true&ts=true"
import script from "./NotificationParametersTypeNotification.vue?vue&type=script&lang=ts"
export * from "./NotificationParametersTypeNotification.vue?vue&type=script&lang=ts"

import "./NotificationParametersTypeNotification.vue?vue&type=style&index=0&id=331ea85b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331ea85b"]])

export default __exports__